import { h } from 'preact';
import * as BaseComp from 'components/bolt/signUpForm/signUpForm.js';
import Store from 'store/store';
import 'store/bolt/signUpBanner';

export default class SignUpForm extends BaseComp.default {
	closeBanner(reason, e) {
		super.closeBanner(reason, e);
		if (reason === 'subscribed') {
			Store.emit('TRACK_SIGNUP_FORM_SUBMIT', { label: '' });
		}
	}
}